<template>
    <div class="home">
        <AccountList v-show="listView" @newAccount="onClickNewFromList" @newAccountType="onClickNewTypeFromList" @editAccount="onEditAccount" @editAccountType="onEditAccountType" :scroll="corY" ref="refreshList" @backClicked="onBackChild"/>
        <AccountForm v-show="formView" :account="account" @backClicked="onBackChild" />
        <AccountTypeForm v-show="formTypeView" :account="accountType" @backClicked="onBackChild"/>
    </div>
</template>

<script>
import AccountList from '@/components/account/ChartOfAccountList.vue'
import AccountForm from '@/components/account/ChartOfAccountForm.vue'
import AccountTypeForm from '@/components/account/ChartOfAccountTypeForm.vue'

export default {
  name: 'ChartOfAccount',
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      formTypeView: false,
      account: {
        id: null,
        type_code: null,
        account_code: null,
        account_name: null,
        notes: null,
        account_balance: null,
        method: null,
        group_id: null,
        group: null,
        saldo: null,
        saldos: [{
          id: null,
          saldo: 0,
          saldo_date: null,
          method: null,
          product_no: null
        }],
        company_no: null,
        calculate: null,
        active: false
      },
      accountType: {
        id: null,
        parent_code: null,
        type_code: null,
        name: null
      }
    }
  },
  mounted () {
    this.$store.dispatch('getAccountGroup')
    this.$store.dispatch('getChartOfAccountList')
    this.$store.dispatch('getCompanyList')
  },
  components: {
    AccountList,
    AccountForm,
    AccountTypeForm
  },
  methods: {
    onClickNewTypeFromList: function () {
      this.listView = false
      this.formView = false
      this.formTypeView = true
      this.accountType = {
        id: null,
        parent_code: null,
        type_code: null,
        name: null
      }
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.formTypeView = false
      this.account = {
        id: null,
        type_code: null,
        account_code: null,
        account_name: null,
        notes: null,
        account_balance: null,
        method: null,
        group_id: null,
        group: null,
        saldo: null,
        saldos: [{
          id: null,
          saldo: 0,
          saldo_date: null,
          method: null,
          product_no: null
        }],
        company_no: null,
        calculate: null,
        active: false
      }
    },
    onEditAccount: function (value) {
      this.account = {
        id: value.id.substring(2),
        type_code: value.parent_code,
        account_code: value.code,
        account_name: value.name,
        notes: value.notes,
        account_balance: value.account_balance,
        method: value.method,
        group_id: value.group_id,
        company_no: value.company_no,
        calculate: value.calculate,
        saldos: value.saldos,
        active: value.active
      }
      this.listView = false
      this.formView = true
      this.formTypeView = false
    },
    onEditAccountType: function (value) {
      this.accountType = {
        id: value.id,
        parent_code: value.parent_code,
        type_code: value.code,
        name: value.name
      }
      this.listView = false
      this.formView = false
      this.formTypeView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.formTypeView = false
      this.$refs.refreshList.refreshAccount()
    }
  }
}
</script>
